export const formatString = (input) => {
    return input.replace(/\s+/g, '').toLowerCase();
}

export const validateString = (value)=> {
    return value === null || value === undefined ? "" : value;
}